import { toast } from 'react-toastify';
import { ToastContent } from '@components/ToastContent';

import type { ImportRejection } from '../types';

const IMPORT_REJECTION_COPY: Record<ImportRejection, { title: string; description: string }> = {
  unsupportedType: {
    title: 'Unsupported File Type',
    description: 'Only .pdf and .docx files can be imported.',
  },
  protectedPdf: {
    title: 'Encrypted File',
    description: 'This file is password protected. Please remove the password and re-upload.',
  },
  unreadableWord: {
    title: "Can't open this Word file",
    description:
      'This file may be password protected, in the old .doc format, or damaged. Remove the password or save it as .docx, then re-upload.',
  },
  corrupt: {
    title: 'Corrupt File',
    description: "This file can't be processed. Please check the file and re-upload a valid version.",
  },
  tooLarge: {
    title: 'File Too Large',
    description: 'This file is too large to import (max 10 MB).',
  },
  multipleFiles: {
    title: 'Multiple Files',
    description: 'Please import one file at a time.',
  },
  importFailed: {
    title: 'Import Failed',
    description: 'Check your connection and try again.',
  },
};

export const showImportRejectedToast = (rejection: ImportRejection) =>
  toast.error(<ToastContent {...IMPORT_REJECTION_COPY[rejection]} />);

export const showImportSuccessToast = () => toast.success('File content imported successfully');

export const showImportCancelledToast = () =>
  toast.warning(
    <ToastContent
      title="Import cancelled"
      description="The clause you were editing changed during the import. Please try again from the current clause."
    />,
  );

export const showFormattingSimplifiedToast = () => toast.warning('Some formatting was simplified');

export const showImportWarningToast = (warnings: string[]) =>
  toast.warning(
    <ToastContent
      title="Imported with omissions"
      description={warnings.map((warning) => (
        <p key={warning} className="text-info-500 text-sm leading-5 font-normal">
          {warning}
        </p>
      ))}
    />,
    { autoClose: false },
  );
